import React from "react";
import { AppShell } from "@/components/AppShell";
import { NotificationSettings } from "@/components/NotificationSettings";
import { AppearanceSettings } from "@/components/AppearanceSettings";
import { SlidersHorizontal } from "lucide-react";

export const ClientSettings = () => {
  return (
    <AppShell mode="client">
      <div className="mb-8">
        <div className="font-mono text-xs text-aurora-purple tracking-[0.3em] uppercase mb-2 flex items-center gap-2">
          <SlidersHorizontal className="w-3.5 h-3.5" /> // Paramètres
        </div>
        <h1 className="font-display text-4xl font-bold uppercase tracking-tight">Paramètres</h1>
        <p className="text-sm text-zinc-400 mt-2">Gérez vos préférences de notification pour cet appareil.</p>
      </div>
      <div className="max-w-2xl">
        <AppearanceSettings />
        <NotificationSettings />
      </div>
    </AppShell>
  );
};

export default ClientSettings;
